import script from "./InitialStep.vue?vue&type=script&setup=true&lang=ts"
export * from "./InitialStep.vue?vue&type=script&setup=true&lang=ts"

import "./InitialStep.vue?vue&type=style&index=0&id=73d376f9&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/app-registration/app-registration/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73d376f9"]])

export default __exports__